import DATA_INTRO_ILO2 from "./Introduction/201DataIntroILO2";
import DATA_BENEFITS_ILO2_1 from "./Introduction/202DataBenefitsILO2_1";
import DATA_BENEFITS_ILO2_2 from "./Introduction/203DataBenefitsILO2_2";
import DATA_NO_1 from "./NO/204DataNO";
import DATA_NO_2 from "./NO/205DataNO";
import DATA_NO_3 from "./NO/206DataNO";
import DATA_NO_4 from "./NO/207DataNO";
import DATA_NO_5 from "./NO/208DataNO";
import DATA_NO_6 from "./NO/209DataNO";
import DATA_NO_7 from "./NO/210DataNO";
import DATA_NO_8 from "./NO/211DataNO";
import DATA_NO_9 from "./NO/212DataNO";
import DATA_NO_10 from "./NO/213DataNO";
import DATA_NO_11 from "./NO/214DataNO";
import DATA_NO_DEMO_ILO2_END from "./NO/215DataNOEnd";

const ILO_WORKFLOW = [
  { page: "ILO_201", type: "intro-template" as TemplateType, data: DATA_INTRO_ILO2 },
  { page: "ILO_202", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_ILO2_1 },
  { page: "ILO_203", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_ILO2_2 },
  { page: "ILO_204", type: "video-journey-template" as TemplateType, data: DATA_NO_1 },
  { page: "ILO_205", type: "video-journey-template" as TemplateType, data: DATA_NO_2 },
  { page: "ILO_206", type: "video-journey-template" as TemplateType, data: DATA_NO_3 },
  { page: "ILO_207", type: "video-journey-template" as TemplateType, data: DATA_NO_4 },
  { page: "ILO_208", type: "video-journey-template" as TemplateType, data: DATA_NO_5 },
  { page: "ILO_209", type: "video-journey-template" as TemplateType, data: DATA_NO_6 },
  { page: "ILO_210", type: "video-journey-template" as TemplateType, data: DATA_NO_7 },
  { page: "ILO_211", type: "video-journey-template" as TemplateType, data: DATA_NO_8 },
  { page: "ILO_212", type: "video-journey-template" as TemplateType, data: DATA_NO_9 },
  { page: "ILO_213", type: "video-journey-template" as TemplateType, data: DATA_NO_10 },
  { page: "ILO_214", type: "video-journey-template" as TemplateType, data: DATA_NO_11 },
  { page: "ILO_215", type: "end-template" as TemplateType, data: DATA_NO_DEMO_ILO2_END },
];

export default ILO_WORKFLOW;
